import { motion } from "framer-motion";
import { ArrowRight, ShoppingBag, Users } from "lucide-react";

export default function CommunityHero({
  community,
  onExploreProducts,
  onJoinCommunity,
}) {
  return (
    <section className="relative overflow-hidden rounded-[36px]">

      {/* HERO IMAGE */}
      <div className="relative h-[520px]">

        <img
          src={community.heroImage}
          alt={community.title}
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div
          className={`
              absolute inset-0
              bg-gradient-to-r
              ${community.gradient}
              opacity-75
          `}
        />

        {/* Glass Blur */}
        <div className="absolute inset-0 backdrop-blur-[2px]" />

        {/* Content */}
        <div className="relative z-20 h-full">

          <div className="max-w-7xl mx-auto px-8 lg:px-16 h-full">

            <div className="grid lg:grid-cols-2 h-full items-center gap-12">

              {/* LEFT */}

              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: .6 }}
              >

                <div className="inline-flex items-center gap-3 px-5 py-2 rounded-full bg-white/20 backdrop-blur-md border border-white/20">

                  <img
                    src={community.logo}
                    className="w-8 h-8 rounded-full"
                    alt=""
                  />

                  <span className="text-white font-semibold">
                    {community.title}
                  </span>

                </div>

                <h1 className="mt-8 text-6xl font-black leading-tight text-white">

                  {community.title}

                </h1>

                <p className="mt-4 text-xl text-white/90 leading-relaxed max-w-xl">

                  {community.subtitle}

                </p>

                <p className="mt-6 text-white/80 leading-8 max-w-xl">

                  {community.description}

                </p>

                {/* BUTTONS */}

                <div className="mt-10 flex flex-wrap gap-4">

                  <button
                    onClick={onJoinCommunity}
                    className="
                        px-8 py-4
                        rounded-full
                        bg-white
                        text-gray-900
                        font-semibold
                        flex
                        items-center
                        gap-2
                        shadow-xl
                        hover:scale-105
                        transition
                    "
                  >

                    <Users size={18} />

                    Join Community

                  </button>

                  <button
                    onClick={onExploreProducts}
                    className="
                        px-8 py-4
                        rounded-full
                        bg-black/30
                        backdrop-blur-md
                        border
                        border-white/20
                        text-white
                        font-semibold
                        flex
                        items-center
                        gap-2
                        hover:bg-black/40
                        transition
                    "
                  >

                    <ShoppingBag size={18} />

                    Explore Collection

                    <ArrowRight size={16} />

                  </button>

                </div>

              </motion.div>

              {/* RIGHT */}

              <motion.div
                initial={{ opacity: 0, scale: .9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: .8 }}
                className="hidden lg:flex justify-end"
              >

                <div
                  className="
                    w-[380px]
                    rounded-[36px]
                    bg-white/10
                    backdrop-blur-xl
                    border
                    border-white/20
                    shadow-2xl
                    p-6
                  "
                >

                  <img
                    src={community.logo}
                    alt=""
                    className="
                        w-full
                        rounded-[28px]
                        object-cover
                    "
                  />

                  <div className="mt-6">

                    <div className="text-white text-3xl font-bold">

                      {community.shortTitle}

                    </div>

                    <div className="text-white/80 mt-2">

                      Build • Become • Belong

                    </div>

                  </div>

                </div>

              </motion.div>

            </div>

          </div>

        </div>

      </div>

      {/* FLOATING STATS */}

      <div
        className="
            relative
            z-30
            -mt-16
            max-w-6xl
            mx-auto
            px-6
        "
      >

        <div
          className="
            bg-white/70
            backdrop-blur-xl
            rounded-[32px]
            border
            border-white/40
            shadow-xl
            p-8
            grid
            grid-cols-2
            lg:grid-cols-4
            gap-8
        "
        >

          <Stat
            label="Members"
            value={community.stats.members}
          />

          <Stat
            label="Threads"
            value={community.stats.posts}
          />

          <Stat
            label="Products"
            value={community.stats.products}
          />

          <Stat
            label="Online"
            value={community.stats.online}
          />

        </div>

      </div>

    </section>
  );
}

function Stat({

  value,

  label,

}) {

  return (

    <div className="text-center">

      <div className="text-4xl font-black text-gray-900">

        {value}

      </div>

      <div className="text-gray-500 mt-2">

        {label}

      </div>

    </div>

  );

}